import { Tab, TabProps } from "@mui/material";
import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";

type AppTabProps = TabProps;

export const AppTab = ({ sx, ...props }: AppTabProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Tab
      sx={{
        textTransform: "none",
        opacity: 1,
        color: colors.surface.onSurfaceVariant,
        ...sx,
      }}
      {...props}
    />
  );
};
